/** @file Caption of a render-feed entry: animation or setup pose, layout, directions, frame/time, overlays. */
import type { RenderEntry, RenderRequestSummary } from '@pose2d/api/render/renderEntry';
import type { CatalogKey, Translate } from '@pose2d/i18n/types';

const LAYOUT: Record<string, CatalogKey | undefined> = { contactSheet: 'aiView.contactSheet', spriteSheet: 'aiView.spriteSheet', gif: 'aiView.gif' };

/** The parts after the animation name; empty ones are left out. */
function details(t: Translate, r: RenderRequestSummary): string[] {
  const layoutKey = r.layout === null ? undefined : LAYOUT[r.layout];
  return [
    r.layout === null ? '' : layoutKey === undefined ? r.layout : t(layoutKey),
    r.directions.join(', '),
    r.frame === null ? '' : t('aiView.frame', { n: r.frame }),
    r.time === null ? '' : t('aiView.time', { s: r.time }),
    r.overlays.join(', '),
  ].filter((part) => part !== '');
}

/** `walk · contact sheet · SE, S · frame 12 · bones`, `r4 vs r7` for a compare, the review label for autoRig. */
export function renderCaption(t: Translate, entry: RenderEntry): string {
  const r = entry.request;
  if (entry.tool === 'autorig') return t('aiView.autorig');
  if (entry.tool === 'render_compare') return t('aiView.compare', { a: r.revA ?? '?', b: r.revB ?? '?' });
  return [r.animation ?? t('aiView.setup'), ...details(t, r)].join(' · ');
}
